import { get } from 'lodash';
import { NavigateFunction } from 'react-router-dom';

import { INotification, ENotificationType, ENotificationChannel } from '../entities/INotification';

const goTo = (path: string, navigate?: NavigateFunction) => {
    if (navigate) {
        navigate(path);
    } else {
        window.location.replace(path);
    }
};

const goToPathOrUrl = (pathOrUrl: string, navigate?: NavigateFunction) => {
    if (!pathOrUrl) return;
    const path = pathOrUrl.startsWith('/')
        ? pathOrUrl
        : (() => {
            try {
                const p = new URL(pathOrUrl, window.location.origin);
                return `${p.pathname}${p.search}${p.hash}`;
            } catch {
                return pathOrUrl;
            }
        })();
    goTo(path, navigate);
};

export const notificationRedirect = (notification: INotification, orgName?: string, navigate?: NavigateFunction) => {
    if (notification.key === ENotificationType.ChannelMessageMentioned || notification.key === ENotificationType.SendingGift || notification.key === ENotificationType.ReceivingGift) {
        if (notification.data.RedirectUrl) {
            goToPathOrUrl(notification.data.RedirectUrl, navigate);
        } else if (notification.data.ThreadId) {
            goTo(`/orgs/${notification.data.OrganizationUrlName}/cluster/${notification.data.ClusterId}/overview/${notification.data.ThreadId}`, navigate);
        } else {
            goTo(`/orgs/${notification.data.OrganizationUrlName}/cluster/${notification.data.ClusterId}/overview`, navigate);
        }
    }

    if (notification.key === ENotificationType.AddedToCluster) {
        goTo(`/orgs/${notification.data.OrganizationUrlName}/cluster/${notification.data.ClusterId}/overview`, navigate);
    }

    if (notification.key === ENotificationType.AddMemberToOrganization) {
        goTo(`/orgs/${notification.data.OrganizationUrlName}/explore`, navigate);
    }

    if (notification.key === ENotificationType.CampaignSubmitted) {
        goToPathOrUrl(notification.data.RedirectUrl, navigate);
    }

    if (notification.key === ENotificationType.RequestAccessToCluster) {
        goTo(`/orgs/${notification.data.OrganizationUrlName}/cluster/${notification.data.ClusterId}/settings#AccessRequest`, navigate);
    }
    if (notification.key === ENotificationType.RequestAccessToResource) {
        goTo(`/orgs/${orgName}/cluster/${notification.data.ResourceId}/settings#AccessRequest`, navigate);
    }

    if (notification.data.Domain === ENotificationType.Profile) {
        goTo(`/profile/${notification.senderDisplayDetails.userId}`, navigate);
    }

    if (notification.data.Domain === ENotificationType.LegalscoreDetails) {
        goTo(`/legalscore/${notification.receiverId}`, navigate);
    }

    if (notification.data.Domain === ENotificationType.EvaluationPage) {
        goTo(`/case/evaluate?caseId=${notification.data.CaseId}&juryEmail=${notification.data.JuryEmail}`, navigate);
    }
    if ((notification.data.Domain || notification.key) === ENotificationType.ClusterDateReminder) {
        goTo(`/orgs/${notification.data.OrganizationUrlName}/cluster/${notification.data.ClusterId}/overview`, navigate);
    }

    if (notification.key === ENotificationType.SharedElement) {
        if (get(notification, 'data.ItemUrl')) {
            window.open(notification.data.ItemUrl, '_blank');
        } else {
            goTo('/drive?account=shared', navigate);
        }
    }

    if (notification.key === ENotificationType.ChannelMessageCreated) {
        goTo(`/orgs/${notification.data.OrganizationUrlName}/cluster/${notification.data.ClusterId}/activity/${notification.data.Id}`, navigate);
    }

    if (notification.key === ENotificationType.ConversationMembersAdded) {
        goTo('/messaging', navigate);
    }

    if (notification.key === ENotificationType.ValidationRequestCreated) {
        goTo(`/orgs/${notification.data.OrganizationUrlName}/cluster/${notification.data.ResourceId}/overview`, navigate);
    }

    if (notification.channelId === ENotificationChannel.LegalDoc && (notification.data?.PathToBranch || notification.data?.UrlToBranch) && !notification.data?.UrlToAmendment) {
        if (notification.data?.PathToBranch) goTo(notification.data.PathToBranch, navigate);
        if (notification.data?.UrlToBranch) goToPathOrUrl(notification.data.UrlToBranch, navigate);
    }

    if (notification.channelId === ENotificationChannel.LegalDoc && (notification.data?.UrlToAmendment)) {
        notification.data?.UrlToAmendment && goToPathOrUrl(notification.data.UrlToAmendment, navigate);
    }

    if (notification.channelId === ENotificationChannel.BackgroudOperation && (notification.data?.RedirectUrl)) {
        notification.data?.RedirectUrl !== null && goToPathOrUrl(notification.data.RedirectUrl, navigate);
    }

    if (notification.key === ENotificationType.SignatureUpdated) {
        goTo(`/orgs/${notification.data.OrganizationUrlName ?? notification.data.organizationUrlName}/cluster/${notification.data.ClusterId ?? notification.data.clusterId}/documents?path=Documents`, navigate);
    }

    if ([ENotificationType.ValidationRequestCompleted, ENotificationType.ValidationRequestRejected, ENotificationType.ValidationRequestWithdrawn, ENotificationType.ValidationRequestNewStageStarted, ENotificationType.ValidationRequestClosedNotificationForCreatorUser as string].includes(notification.key)) {
        if (notification.key === ENotificationType.ValidationRequestNewStageStarted && notification.data?.resources?.[0]?.Type === 'ClusterOverview') {
            goTo(`/orgs/${notification.data.organizationUrlName}/cluster/${notification.data.resourceId}/overview`, navigate);
        } else {
            goTo(`/orgs/${notification.data.organizationUrlName}/cluster/${notification.data.resourceId}/activity?panelType=Approval&validationId=${notification.data.validationRequestId}&clusterId=${notification.data.resourceId}`, navigate);
        }
    }

    if ([ENotificationType.ValidatorVotedOnBehalf as string].includes(notification.key)) {
        goTo(`/orgs/${notification.data.organizationUrlName}/cluster/${notification.data.clusterId}/overview?panelType=Approval&validationId=${notification.data.validationRequestId}&clusterId=${notification.data.clusterId}`, navigate);
    }

    if ([ENotificationType.InvestorCommentGenerateCompleted, ENotificationType.SideLetterGenerateCompleted].includes(notification.key as ENotificationType)) {
        if (notification.data?.RedirectUri) {
            goToPathOrUrl(notification.data.RedirectUri, navigate);
        }
    }
};